<template>
  <div>
    <a-form-model
      class="fromStyle"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item ref="brand_name" label="商品名称" prop="brand_name">
        <a-input style="width:300px" v-model="form.brand_name" />
      </a-form-model-item>
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="firm_id" label="设备厂商" prop="firm_id">
        <a-checkbox-group v-model="form.firm_id">
          <a-checkbox :value="1" name="firm_id">
            易触
          </a-checkbox>
          <a-checkbox :value="2" name="firm_id">
            华屹1
          </a-checkbox>
          <a-checkbox :value="3" name="firm_id">
            华屹2
          </a-checkbox>
          <a-checkbox :value="4" name="firm_id">
            卡游
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item
        ref="yc_number"
        v-if="form.firm_id.includes(1)"
        label="易触编号"
        prop="yc_number"
      >
        <a-input v-model="form.yc_number" />
      </a-form-model-item>
      <a-form-model-item
        ref="hy_number"
        v-if="form.firm_id.includes(2)"
        label="华屹1编号"
        prop="hy_number"
      >
        <a-input v-model="form.hy_number" />
      </a-form-model-item>
      <a-form-model-item
        ref="hy2_number"
        v-if="form.firm_id.includes(3)"
        label="华屹2编号"
        prop="hy2_number"
      >
        <a-input v-model="form.hy2_number" />
      </a-form-model-item>
      <a-form-model-item
        ref="ky_number"
        v-if="form.firm_id.includes(4)"
        label="卡游"
        prop="ky_number"
      >
        <a-input v-model="form.ky_number" />
      </a-form-model-item>
      <a-form-model-item ref="count_type" label="单位类型" prop="count_type">
        <a-radio-group v-model="form.count_type">
          <a-radio :value="1">单个装</a-radio>
          <a-radio :value="2">整盒装</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.count_type == 2"
        ref="count_num"
        label="换算数量"
        prop="count_num"
      >
        <a-input-number v-model="form.count_num" />
        <span>个</span>
      </a-form-model-item>
      <a-form-model-item label="图片" ref="image" prop="image">
        <div class="upImgStyle">
          <input id="travel" type="file" accept="image/*" @change="goodsPic" />
          <img :src="imageUrlShow" alt="" />
        </div>
      </a-form-model-item>
      <a-form-model-item ref="price" label="价格" prop="price">
        <a-input-number v-model="form.price" />
      </a-form-model-item>
      <a-form-model-item
        v-if="form.firm_id.includes(4)"
        ref="ky_container"
        label="货道容量"
        prop="ky_container"
      >
        <a-input-number v-model="form.ky_container" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button @click="resetForm">
          重置
        </a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        brand_name: "",
        project_id: "",
        firm_id: [],
        yc_number: "",
        hy_number: "",
        hy2_number: "",
        ky_number: "",
        is_upper: 2,
        image: "",
        price: "",
        count_type: "",
        count_num: "",
        ky_container: ""
      },
      rules: {
        brand_name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        firm_id: [
          {
            required: true,
            message: "请选择厂商",
            trigger: "change"
          }
        ],
        yc_number: [
          {
            required: true,
            message: "请输入易触编号",
            trigger: "blur"
          }
        ],
        hy_number: [
          {
            required: true,
            message: "请输入华屹1编号",
            trigger: "blur"
          }
        ],
        hy2_number: [
          {
            required: true,
            message: "请输入华屹2编号",
            trigger: "blur"
          }
        ],
        ky_number: [
          {
            required: true,
            message: "请输入卡游编号",
            trigger: "blur"
          }
        ],
        image: [
          {
            required: true,
            message: "请选择图片",
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          }
        ],
        ky_container: [
          {
            required: true,
            message: "请输入货道容量",
            trigger: "blur"
          }
        ],
        count_type: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "change"
          }
        ],
        count_num: [
          {
            required: true,
            message: "请输入换算数量",
            trigger: "blur"
          }
        ]
      },
      proList: [],
      imageUrlShow: require("../../assets/equipment/add.jpg")
    };
  },
  mounted() {
    this.getPro();
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    goodsPic(e) {
      if (e.target.files != "") {
        this.getUpImgToken(e);
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          this.imageUrlShow = reader.result;
        };
      }
    },
    getUpImgToken(e) {
      let _this = this;
      let url = this.httpsBasic.url + "cloud/Qiniu/getToken";
      axios
        .post(url, {
          count: 1
        })
        .then(res => {
          this.form.image = res.data.data.business_file_key;
          // console.log(this.getToken1);
          var config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          };
          var putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          var observable = qiniu.upload(
            e.target.files[0],
            res.data.data.keys[0],
            res.data.data.token,
            putExtra,
            config
          );
          var observer = {
            next(res) {
              // console.log("上传中...");
            },
            error(err) {
              // console.log(err)
              _this.$info({
                title: "提示",
                content: "错误码：" + err.code + "！请重新选择图片",
                onOk() {}
              });
            },
            complete(res) {
              // console.log("上传成功");
            }
          };
          var subscription = observable.subscribe(observer); // 上传开始
        });
    }, //上传至七牛云
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      let brand_firm = [];
      this.form.firm_id.forEach(item => {
        if (item == 1) {
          brand_firm.push({
            firm_id: item,
            number: this.form.yc_number
          });
        } else if (item == 2) {
          brand_firm.push({
            firm_id: item,
            number: this.form.hy_number
          });
        } else if (item == 3) {
          brand_firm.push({
            firm_id: item,
            number: this.form.hy2_number
          });
        } else if (item == 4) {
          brand_firm.push({
            firm_id: item,
            number: this.form.ky_number
          });
        }
      });
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url + this.httpsBasic.equipment + "Brand/add";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            brand_name: this.form.brand_name,
            project_id: this.form.project_id,
            is_upper: this.form.is_upper,
            count_type: this.form.count_type,
            count_num: this.form.count_type == 1 ? 1 : this.form.count_num,
            price: this.form.price,
            brand_firm: JSON.stringify(brand_firm),
            image: this.form.image,
            ky_container: this.form.ky_container
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.resetForm();
              this.$emit("hideInAdd", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.imageUrlShow = require("../../assets/equipment/add.jpg");
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less">
.fromStyle {
  margin-top: 30px;
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
  .upImgStyle {
    position: relative;
    display: inline-block;
    min-width: 300px;
    vertical-align: top;
    > input {
      vertical-align: top;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      z-index: 1;
    }
    > img {
      vertical-align: top;
      display: inline-block;
      border: 1px solid #d9d9d9;
      width: 100px;
      height: 100px;
      text-align: center;
      line-height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      i {
        line-height: 100px;
      }
    }
  }
}
</style>
